import { isValidEmail, isValidPhone, normalizeWhitespace, normalizePhone } from '../../utils/validation';

export type ContactFieldName = 'contactName' | 'contactMobil' | 'contactEmail';

export const validateContactField = (name: ContactFieldName, value: string): string => {
  const normalized = normalizeWhitespace(value);
  switch (name) {
    case 'contactName':
      return normalized ? '' : 'Navn er påkrævet.';
    case 'contactMobil':
      if (!normalized) {return 'Mobilnummer er påkrævet.';}
      return isValidPhone(normalized) ? '' : 'Mobilnummer skal være 8 cifre.';
    case 'contactEmail':
      if (!normalized) {return 'Email er påkrævet.';}
      return isValidEmail(normalized) ? '' : 'Indtast en gyldig email.';
    default:
      return '';
  }
};

/**
 * Normalizes a contact field value (especially useful for phone numbers)
 */
export const normalizeContactField = (name: ContactFieldName, value: string): string => {
  switch (name) {
    case 'contactMobil':
      return normalizePhone(value);
    case 'contactName':
    case 'contactEmail':
      return normalizeWhitespace(value);
    default:
      return value;
  }
};

export const CONTACT_DEFAULT_INFO = 'Vi sender påmindelser og kvitteringer via mail eller SMS, så du får besked om din henvendelse.';
export const CONTACT_DEFAULT_HINT = 'Meddelelser sendes via almindelig mail/SMS og indeholder ikke følsomme oplysninger.';
